@use "variables" as *;
@use "../../helpers/headerSectionStyles/headerSectionStyles.scss" as *;
@use "common/config/breakpoints";

.spinner {
  display: flex;
  justify-content: center;
  align-items: center;
  height: calc(100vh - 72px);
}

.headerContainer {
  @include container;
}

.innerHeaderContainer {
  @include max-content-width;
}

.backButton {
  display: flex;
  align-items: center;
  gap: $spacing-1;
  margin-bottom: $spacing-4;
}

.heading {
  margin-bottom: $spacing-2;
}

.category {
  color: $content-secondary-color;
  margin-bottom: $spacing-4;
}

.content {
  h1 {
    font-size: $font-size-h1;
    line-height: $line-height-h1;
  }

  h2 {
    font-size: $font-size-h2;
    line-height: $line-height-h2;
    margin-top: $spacing-6;
    margin-bottom: $spacing-3;
  }

  h3 {
    font-size: $font-size-h3;
    line-height: $line-height-h3;
    margin-top: $spacing-4;
    margin-bottom: $spacing-2;
  }

  h4 {
    font-size: $font-size-h4;
    line-height: $line-height-h4;
    margin-top: $spacing-3;
    margin-bottom: $spacing-2;
  }

  img {
    max-width: 100%;
    height: auto;
    display: block;
    margin: $spacing-4 0;
    border: 2px solid $grayscale-30-color;
    border-radius: $border-radius;

    @media (min-width: (breakpoints.$breakpoint-sm)) {
      max-width: 75%;
    }

    @media (min-width: (breakpoints.$breakpoint-lg)) {
      max-width: 50%;
    }

    @media (min-width: (breakpoints.$breakpoint-xl)) {
      max-width: 35%;
    }
  }

  hr {
    margin: $spacing-4 0;
    border: none;
    border-top: 2px solid $grayscale-30-color;
  }

  ul,
  ol {
    padding-left: $spacing-3;
  }

  li {
    margin: $spacing-1 0;
  }

  p {
    margin: $spacing-2 0;
  }
}
